import { Component, Inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogClose } from '@angular/material/dialog';

export interface MessageData {
  isIssue: boolean
  isBuyer?: boolean
  message?: string
  placeholder?: string
}

@Component({
  selector: 'msh-message-dialog',
  imports: [FormsModule, MatDialogClose],
  template: `
   <div class=" min-w-[50vw]">
    <div class=" p-8">
      <textarea [(ngModel)]="data.message"
        name="message"
        class="border"
        rows="7"
        [placeholder]="data.placeholder || 'Message'"
      ></textarea>
    </div>
    <div class="bg-copy/10 flex justify-between py-4 px-6 gap-3">
        <button mat-flat-button [mat-dialog-close]="false">Close</button>
        <button [disabled]="!data.message" [mat-dialog-close]="data">{{ data.isIssue ? 'Report Issue' : 'Send Message'}}</button>
    </div>
   </div>
  `,
  styles: ``
})
export class MessageDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<MessageDialogComponent>, 
    @Inject(MAT_DIALOG_DATA) public data: MessageData
  ){ }
}
